export { default } from "./WritePromptQuestion";
